var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBackupCard = function SvgBackupCard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 700 301"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#backup_card_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 700,
    height: 301,
    fill: "#EBEBEB",
    rx: 8
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#BABABA",
    strokeWidth: 0.5,
    d: "M11.244 255.636c96.51-.647 201.272-1.289 297.782-.762M342.314 255.586h38.035"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#333",
    strokeWidth: 0.5,
    d: "M342.88 255.59c14.953.044-2.248.002 19.862-.004"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#BABABA",
    strokeWidth: 0.5,
    d: "M476.63 88.27v195.346M238.8 24.106v213.89M242.048 25.953V236.87M225.246 18.035v220.142"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#DBDBDB",
    strokeWidth: 0.5,
    d: "m42.28 1.45.836 256.114"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#666",
    strokeWidth: 0.2,
    d: "m41.619 1.45.837 256.114"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#BABABA",
    strokeWidth: 0.5,
    d: "M316.625 47.602V110.7M456.052 45.344l3.297 246.605M1.497 255.032l221.083 8.227 36.471-8.54M255.46 243.492v24.942M233.512 24.71v242.782"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#666",
    stroke: "#DBDBDB",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 66.577,
    height: 17.565,
    x: 350.034,
    y: 218.516,
    rx: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 70.585,
    height: 17.565,
    x: 348.036,
    y: 224.375,
    rx: 2.5
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m416.251 127.82.312-.02 6.854 109.662-.313.02zM405.008 128.485l.921-.057 6.853 109.661s-2.664.157-2.645-.189c1.229-22.476-5.129-109.415-5.129-109.415M396.646 128.821l-.923.017 1.962 109.857s2.668-.057 2.621-.4c-3.027-22.305-3.66-109.474-3.66-109.474M380.317 129.478l-.923.016 1.962 109.858s2.668-.057 2.621-.401c-3.027-22.305-3.66-109.473-3.66-109.473M388.692 129.298l.92-.058 6.853 109.661s-2.664.158-2.645-.188c1.229-22.477-5.128-109.415-5.128-109.415M372.362 129.954l.921-.057 6.853 109.661s-2.664.157-2.645-.189c1.229-22.476-5.129-109.415-5.129-109.415M410.697 127.88l.92-.058 6.854 109.661s-2.665.158-2.646-.188c1.229-22.477-5.128-109.415-5.128-109.415"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m412.963 127.407.921-.057 6.853 109.661s-2.664.157-2.645-.189c1.229-22.476-5.129-109.415-5.129-109.415M420.183 126.993l.921-.057 6.853 109.661s-2.664.157-2.645-.189c1.229-22.476-5.129-109.415-5.129-109.415"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m422.469 127.024.921-.057 6.853 109.661s-2.664.157-2.645-.189c1.229-22.476-5.129-109.415-5.129-109.415M402.789 128.892l-.346-.007 3.461 109.262s1.06.302 1.034-.042c-1.694-22.294-4.149-109.213-4.149-109.213M398.891 129.048l.344-.035 5.311 109.188s-1.033.386-1.035.042c-.099-22.359-4.62-109.195-4.62-109.195M370.814 130.661l-.346-.007 3.46 109.263s1.061.301 1.035-.042c-1.694-22.295-4.149-109.214-4.149-109.214M405.2 128.763h-.527l2.975 109.282s1.61.28 1.578-.063c-2.112-22.278-4.026-109.219-4.026-109.219M396.477 129.114l.525-.041 5.797 109.168s-1.583.408-1.578.063c.319-22.375-4.744-109.19-4.744-109.19M380.148 129.77l.525-.041 5.797 109.168s-1.583.408-1.578.063c.319-22.375-4.744-109.19-4.744-109.19M388.884 129.575l-.527.001 2.975 109.281s1.61.28 1.578-.063c-2.113-22.278-4.026-109.219-4.026-109.219M372.555 130.231l-.527.001 2.975 109.282s1.61.279 1.577-.064c-2.112-22.277-4.025-109.219-4.025-109.219"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m426.56 126.38-.527.001 2.975 109.281s1.61.28 1.578-.063c-2.112-22.278-4.026-109.219-4.026-109.219M417.586 127.336l.92-.058 6.854 109.662-.92.057zM384.122 129.102l.326-.017 5.42 109.72-.326.018zM372.4 129.689l.96-.052 5.42 109.722s-2.778.138-2.753-.208c1.633-22.47-3.627-109.462-3.627-109.462M363.682 129.966l-.96.01.32 109.883s2.781-.038 2.738-.382c-2.804-22.329-2.098-109.511-2.098-109.511M346.662 130.505l-.961.01.32 109.883s2.781-.038 2.738-.382c-2.804-22.329-2.097-109.511-2.097-109.511M355.389 130.384l.96-.051 5.42 109.721s-2.778.138-2.753-.208c1.633-22.469-3.627-109.462-3.627-109.462M338.368 130.927l.96-.051 5.42 109.721s-2.778.138-2.753-.208c1.633-22.47-3.627-109.462-3.627-109.462M378.335 129.122l.96-.051 5.42 109.721s-2.778.139-2.752-.207c1.632-22.47-3.628-109.463-3.628-109.463"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m380.703 128.669.96-.051 5.421 109.721s-2.778.139-2.753-.207c1.632-22.47-3.628-109.463-3.628-109.463M388.231 128.302l.96-.051 5.42 109.721s-2.778.138-2.752-.208c1.632-22.47-3.628-109.462-3.628-109.462"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m390.613 128.353.959-.051 5.421 109.721s-2.778.138-2.753-.208c1.633-22.47-3.627-109.462-3.627-109.462M370.081 130.079l-.36-.009 1.892 109.298s1.1.309 1.078-.034c-1.414-22.309-2.61-109.255-2.61-109.255M366.018 130.208l.36-.032 3.82 109.237s-1.082.379-1.078.034c.247-22.361-3.102-109.239-3.102-109.239M336.743 131.622l-.36-.009 1.892 109.298s1.1.309 1.079-.034c-1.415-22.309-2.611-109.255-2.611-109.255M372.596 129.97l-.549-.003 1.386 109.314s1.673.291 1.645-.052c-1.852-22.295-2.482-109.259-2.482-109.259M363.502 130.255l.548-.038 4.327 109.221s-1.655.397-1.645.052c.684-22.375-3.23-109.235-3.23-109.235M346.481 130.794l.548-.038 4.327 109.221s-1.655.397-1.645.052c.684-22.375-3.23-109.235-3.23-109.235M355.585 130.665l-.549-.003 1.386 109.314s1.673.291 1.645-.052c-1.851-22.295-2.482-109.259-2.482-109.259M338.564 131.204l-.549-.003 1.386 109.314s1.673.291 1.645-.052c-1.851-22.295-2.482-109.259-2.482-109.259"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m394.884 127.735-.549-.003 1.386 109.315s1.673.291 1.645-.053c-1.851-22.295-2.482-109.259-2.482-109.259M385.521 128.625l.96-.051 5.42 109.721-.96.051z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    stroke: "#1F1F1F",
    strokeWidth: 4,
    d: "m381.299 129.152-45.593 2.746 3.295 109.317h46.693z",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    stroke: "#1F1F1F",
    strokeWidth: 4,
    d: "m427.437 126.367-45.593 2.809 3.296 111.804h46.692z",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1F1F1F",
    strokeWidth: 4,
    d: "m381.299 129.152-45.593 2.746 3.295 109.317h46.693z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1F1F1F",
    strokeWidth: 4,
    d: "m427.437 126.367-45.593 2.809 3.296 111.804h46.692z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m299.356 136.516.332-.01 3.768 103.541-.331.01zM287.406 136.851l.978-.03 3.769 103.542s-2.832.079-2.801-.247c2.022-21.154-1.946-103.265-1.946-103.265M278.523 136.953l-.979-.008-1.428 103.6s2.833.015 2.794-.31c-2.499-21.102-.387-103.282-.387-103.282M261.176 137.148l-.979-.008-1.428 103.6s2.833.016 2.794-.309c-2.499-21.103-.387-103.283-.387-103.283M270.068 137.195l.979-.03 3.768 103.541s-2.832.08-2.801-.246c2.022-21.154-1.946-103.265-1.946-103.265M252.722 137.39l.978-.03 3.769 103.542s-2.832.079-2.801-.247c2.022-21.154-1.946-103.265-1.946-103.265M293.461 136.426l.979-.031 3.768 103.542s-2.831.079-2.8-.247c2.021-21.153-1.947-103.264-1.947-103.264"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m295.88 136.043.979-.031 3.768 103.542s-2.831.079-2.8-.246c2.022-21.154-1.947-103.265-1.947-103.265M303.554 135.836l.978-.031 3.769 103.542s-2.832.079-2.801-.246c2.022-21.154-1.946-103.265-1.946-103.265"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m305.978 135.93.979-.031 3.768 103.542s-2.831.079-2.8-.247c2.022-21.154-1.947-103.264-1.947-103.264M285.038 137.176l-.367-.016.182 103.078s1.116.312 1.099-.012c-1.085-21.058-.914-103.05-.914-103.05M280.898 137.222l.367-.023 2.147 103.056s-1.109.337-1.099.012c.608-21.077-1.415-103.045-1.415-103.045M251.057 138.019l-.367-.015.182 103.078s1.115.312 1.099-.012c-1.085-21.059-.914-103.051-.914-103.051M287.602 137.117l-.56-.013-.334 103.084s1.7.305 1.676-.019c-1.529-21.054-.782-103.052-.782-103.052M278.334 137.222l.559-.025 2.663 103.05s-1.692.343-1.676.019c1.053-21.083-1.546-103.044-1.546-103.044M260.988 137.418l.559-.026 2.663 103.05s-1.692.343-1.676.019c1.053-21.083-1.546-103.043-1.546-103.043M270.264 137.465l-.56-.013-.334 103.083s1.7.305 1.676-.019c-1.529-21.053-.782-103.051-.782-103.051M252.917 137.66l-.559-.013-.334 103.084s1.699.305 1.676-.019c-1.529-21.054-.783-103.052-.783-103.052"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m310.34 135.426-.56-.013-.334 103.083s1.7.305 1.676-.019c-1.529-21.053-.782-103.051-.782-103.051M300.788 136.09l.979-.03 3.768 103.541-.978.03z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    stroke: "#1F1F1F",
    strokeWidth: 4,
    d: "m279.989 136.234-30.547 2.59 2.209 103.076h31.282z",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    stroke: "#1F1F1F",
    strokeWidth: 4,
    d: "m310.9 133.605-30.546 2.649 2.208 105.423h31.282z",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1F1F1F",
    strokeWidth: 4,
    d: "m279.989 136.234-30.547 2.59 2.209 103.076h31.282z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1F1F1F",
    strokeWidth: 4,
    d: "m310.9 133.605-30.546 2.649 2.208 105.423h31.282z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1F1F1F",
    d: "M335 163.5V148l152-6.5V158z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BABABA",
    d: "m486.5 157.738-151.5 5.5v3.5l151.5-5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1F1F1F",
    d: "M249 167v-15.5l63.5-3v16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BABABA",
    d: "m312.556 163.862-63.611 3.016-.149 3.498 63.59-2.517z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.773,
    cy: 10.908,
    fill: "url(#backup_card_svg__b)",
    rx: 10.773,
    ry: 10.908,
    transform: "matrix(.69555 -.71848 .74108 .67142 408.929 215.492)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.773,
    cy: 10.908,
    fill: "url(#backup_card_svg__c)",
    rx: 10.773,
    ry: 10.908,
    transform: "matrix(.69555 -.71848 .74108 .67142 422.875 212.727)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.819,
    cy: 10.454,
    fill: "#BABABA",
    rx: 9.819,
    ry: 10.454,
    transform: "matrix(.74966 -.66182 .68622 .7274 431.952 219.477)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.819,
    cy: 10.454,
    fill: "url(#backup_card_svg__d)",
    rx: 9.819,
    ry: 10.454,
    transform: "matrix(.74966 -.66182 .68622 .7274 431.952 219.477)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.269,
    cy: 14.126,
    fill: "#BABABA",
    rx: 13.269,
    ry: 14.126,
    transform: "matrix(.74966 -.66182 .68622 .7274 433.299 227.91)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.269,
    cy: 14.126,
    fill: "url(#backup_card_svg__e)",
    rx: 13.269,
    ry: 14.126,
    transform: "matrix(.74966 -.66182 .68622 .7274 433.299 227.91)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.473,
    cy: 19.148,
    fill: "#BABABA",
    rx: 18.473,
    ry: 19.148,
    transform: "matrix(.77894 -.6271 .6523 .75796 398.13 226.848)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.473,
    cy: 19.148,
    fill: "url(#backup_card_svg__f)",
    rx: 18.473,
    ry: 19.148,
    transform: "matrix(.77894 -.6271 .6523 .75796 398.13 226.848)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 11.556,
    cy: 11.978,
    fill: "#BABABA",
    rx: 11.556,
    ry: 11.978,
    transform: "matrix(.77894 -.6271 .6523 .75796 372.81 242.215)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 11.556,
    cy: 11.978,
    fill: "url(#backup_card_svg__g)",
    rx: 11.556,
    ry: 11.978,
    transform: "matrix(.77894 -.6271 .6523 .75796 372.81 242.215)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 11.556,
    cy: 11.978,
    fill: "#BABABA",
    rx: 11.556,
    ry: 11.978,
    transform: "matrix(.77894 -.6271 .6523 .75796 302.196 242.25)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 11.556,
    cy: 11.978,
    fill: "url(#backup_card_svg__h)",
    rx: 11.556,
    ry: 11.978,
    transform: "matrix(.77894 -.6271 .6523 .75796 302.196 242.25)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 11.556,
    cy: 11.978,
    fill: "#BABABA",
    rx: 11.556,
    ry: 11.978,
    transform: "matrix(.77894 -.6271 .6523 .75796 316.106 242.215)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 11.556,
    cy: 11.978,
    fill: "url(#backup_card_svg__i)",
    rx: 11.556,
    ry: 11.978,
    transform: "matrix(.77894 -.6271 .6523 .75796 316.106 242.215)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.076,
    cy: 8.371,
    fill: "#BABABA",
    rx: 8.076,
    ry: 8.371,
    transform: "matrix(.77894 -.6271 .6523 .75796 314.353 229.781)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.076,
    cy: 8.371,
    fill: "url(#backup_card_svg__j)",
    rx: 8.076,
    ry: 8.371,
    transform: "matrix(.77894 -.6271 .6523 .75796 314.353 229.781)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.076,
    cy: 8.371,
    fill: "#BABABA",
    rx: 8.076,
    ry: 8.371,
    transform: "matrix(.77894 -.6271 .6523 .75796 319.611 233.305)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.076,
    cy: 8.371,
    fill: "url(#backup_card_svg__k)",
    rx: 8.076,
    ry: 8.371,
    transform: "matrix(.77894 -.6271 .6523 .75796 319.611 233.305)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.892,
    cy: 13.363,
    fill: "#BABABA",
    rx: 12.892,
    ry: 13.363,
    transform: "matrix(.77894 -.6271 .6523 .75796 384.558 240.891)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.892,
    cy: 13.363,
    fill: "url(#backup_card_svg__l)",
    rx: 12.892,
    ry: 13.363,
    transform: "matrix(.77894 -.6271 .6523 .75796 384.558 240.891)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.473,
    cy: 19.148,
    fill: "#BABABA",
    rx: 18.473,
    ry: 19.148,
    transform: "matrix(.77894 -.6271 .6523 .75796 398.255 243.812)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.473,
    cy: 19.148,
    fill: "url(#backup_card_svg__m)",
    rx: 18.473,
    ry: 19.148,
    transform: "matrix(.77894 -.6271 .6523 .75796 398.255 243.812)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.473,
    cy: 19.148,
    fill: "#BABABA",
    rx: 18.473,
    ry: 19.148,
    transform: "matrix(.77894 -.6271 .6523 .75796 421.212 243.07)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.473,
    cy: 19.148,
    fill: "url(#backup_card_svg__n)",
    rx: 18.473,
    ry: 19.148,
    transform: "matrix(.77894 -.6271 .6523 .75796 421.212 243.07)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.612,
    cy: 8.927,
    fill: "#BABABA",
    rx: 8.612,
    ry: 8.927,
    transform: "matrix(.77894 -.6271 .6523 .75796 471.792 131.445)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.612,
    cy: 8.927,
    fill: "url(#backup_card_svg__o)",
    rx: 8.612,
    ry: 8.927,
    transform: "matrix(.77894 -.6271 .6523 .75796 471.792 131.445)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.712,
    cy: 6.957,
    fill: "#BABABA",
    rx: 6.712,
    ry: 6.957,
    transform: "matrix(.77894 -.6271 .6523 .75796 483.395 134.262)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.712,
    cy: 6.957,
    fill: "url(#backup_card_svg__p)",
    rx: 6.712,
    ry: 6.957,
    transform: "matrix(.77894 -.6271 .6523 .75796 483.395 134.262)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.189,
    cy: 5.379,
    fill: "#BABABA",
    rx: 5.189,
    ry: 5.379,
    transform: "matrix(.77894 -.6271 .6523 .75796 489.01 139.633)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.189,
    cy: 5.379,
    fill: "url(#backup_card_svg__q)",
    rx: 5.189,
    ry: 5.379,
    transform: "matrix(.77894 -.6271 .6523 .75796 489.01 139.633)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.189,
    cy: 5.379,
    fill: "#BABABA",
    rx: 5.189,
    ry: 5.379,
    transform: "matrix(.77894 -.6271 .6523 .75796 489.222 147.645)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.189,
    cy: 5.379,
    fill: "url(#backup_card_svg__r)",
    rx: 5.189,
    ry: 5.379,
    transform: "matrix(.77894 -.6271 .6523 .75796 489.222 147.645)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.986,
    cy: 4.131,
    fill: "#BABABA",
    rx: 3.986,
    ry: 4.131,
    transform: "matrix(.77894 -.6271 .6523 .75796 494.376 152.797)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.986,
    cy: 4.131,
    fill: "url(#backup_card_svg__s)",
    rx: 3.986,
    ry: 4.131,
    transform: "matrix(.77894 -.6271 .6523 .75796 494.376 152.797)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#backup_card_svg__t)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#DBDBDB",
    d: "M456.424 93.59 233.08 111.824v21.961l223.344-15.746z"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    d: "m233.246 133.644 31.714-2.024m-31.714-19.863 15.099-1.312"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#666",
    strokeWidth: 0.5,
    d: "m456.73 93.625 19.884 21.646"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2A2A2A",
    strokeWidth: 0.6,
    d: "m456.516 118.188 19.99 16.948m-.002 51.654v59.545"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#666",
    d: "M316.698 94.473 112.537.215h-8.461l212.622 96.2z"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#backup_card_svg__u)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M42.719 2.781-.074 10.415v4.82L42.72 7.551l255.832 96.306 4.331-.221z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#DBDBDB",
    d: "M42.615 5.406-.176 13.04v4.82l42.791-7.683 255.832 96.306 4.331-.221z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#BABABA",
    strokeWidth: 0.5,
    d: "m.816 126.977 40.873-3.5 206.125 27.449M-.174 274.617l225.491-36.668h13.403l3.256-.871h7.565"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2A2A2A",
    strokeWidth: 0.5,
    d: "m42.93 123.773 12.06 1.618"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#959595",
    strokeWidth: 3,
    d: "M192.758 171.984v101.263a6 6 0 0 0 6.044 6l289.068-2.098a6 6 0 0 0 5.957-6v-41.484a6 6 0 0 1 6-6h11.122"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#backup_card_svg__v)",
    opacity: 0.55
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m452.379 285.764 207.236-17.889 4.764 23-71.222-.511-136.49-4.6z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#1F1F1F",
    d: "m529.617 196.748-12.074 21.905c-.793.435-3.275 2.671-5.178 3.74-2.291 1.286-7.019 3.087-9.994 7.717-.749 1.166-2.615 47.372-1.782 51.884.666 3.609 3.365 5.262 4.79 5.381 7.099.198 17 .5 21.025.318.38-.018.751-.185 1.087-.407.918-.607 1.308-1.76 1.336-2.86l.076-3.026 101.485.594h-.594c0 1.899.356 5.58 4.045 5.699 6.424-.159 17.242.193 19.54-.318 4.5-1 5.159-3.708 5-4.5-.237-16.463-1.267-49.132-2.409-52.171s-5.158-6.174-7.14-7.124l-7.853-5.699c-3.728-6.411-11.546-20.48-14.277-24.695-2.615-4.037-10.527-6.827-14.869-7.242l-12.552-.891-13.982-.178c-11.58.079-34.739.356-41.639 1.306-6.998.963-12.772 8.113-14.041 10.567"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#666",
    d: "m529.617 196.748-12.074 21.905c-.793.435-3.275 2.671-5.178 3.74-2.291 1.286-7.019 3.087-9.994 7.717-.679 1.057-2.448 35.327-2.152 45.089.043 1.422.699 2.714 1.704 3.72a5.27 5.27 0 0 0 3.514 1.539l23.466.942 100.89.594c2.086.381 15.898-.738 19.586-.619 4.5-.5 3.5 0 7-1 2.264-.647 2-2.5 2-4-.238-16.463-1.267-42.632-2.409-45.671s-5.158-6.174-7.141-7.124l-7.852-5.699c-3.728-6.411-11.546-20.48-14.277-24.695-2.615-4.037-10.527-6.827-14.87-7.242l-12.551-.891-13.982-.178c-11.58.079-34.739.356-41.639 1.306-6.998.963-12.772 8.113-14.041 10.567"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1F1F1F",
    strokeLinecap: "round",
    d: "m536.379 272.287 3.768-6.58c.549-.681 2.213-1.996 4.473-1.815s47.404.378 69.693.454c1.491-.076 4.851.317 6.357 2.496s3.768 5.596 4.709 7.033",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1F1F1F",
    strokeLinecap: "round",
    d: "m535.379 273.287 3.852-6.58c.562-.681 2.263-1.996 4.574-1.815s48.469.378 71.26.454c1.524-.076 4.959.317 6.5 2.496 1.54 2.178 3.851 5.596 4.814 7.033",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1F1F1F",
    strokeLinecap: "round",
    strokeWidth: 3,
    d: "M551.379 244.875h58M553.551 249h53.423m-51.314 4.208h49.719m-47.5 4.667h46",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFC582",
    d: "M646.268 232.513c-6.414-2.075-26.99 1.403-30.016 3.417-3.109 2.069-1.107 6.157 2.441 7.324l5.231 1.72c1.813.597 3.712.94 5.615.779 2.561-.217 5.85-.77 10.92-2.014 8.956-2.196 7.141-10.372 5.809-11.226M514.459 232.513c6.231-2.075 26.219 1.403 29.158 3.417 3.063 2.098 1.048 6.166-2.468 7.357l-4.89 1.656c-1.823.617-3.738.974-5.656.8-2.473-.223-5.646-.778-10.501-2.004-8.7-2.196-6.937-10.372-5.643-11.226"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#585858",
    d: "m529.575 197.841-12.122 22.077c-.796.438 5.001 5.325 9.996 7.598l12.452 4.568a18.76 18.76 0 0 1 7.669 5.272 11.94 11.94 0 0 0 8.894 4.085l45.155.374c4.552.038 8.733-2.259 12.112-5.31.352-.317.723-.671 1.148-1.13 2.708-2.916 11.302-4.405 16-6 4.301-2.393 7.5-6 7.5-6 1.067-1.393 2.849-3.677 3-4.235-4-6.265-11.758-20.517-14.5-24.765-2.625-4.068-8.21-6.406-14.682-7.363l-12.96-.898-13.76-.239c-11.626.08-34.877.359-41.805 1.316-7.025.971-12.823 8.177-14.097 10.65"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1F1F1F",
    stroke: "#1F1F1F",
    d: "m536.173 195.426-11.794 19.54h21.275c11.1.076 35.15-.409 45.325-.227s33.84.833 44.4 1.136c-1.618-2.878-5.688-9.952-9.018-15.223-4.163-6.589-7.46-10.016-16.188-10.679-28.444-2.158-48.331-.568-60.125 0-4.065.196-8.787.796-13.875 5.453Z"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#backup_card_svg__w)",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M574.122 270.763c0 24.239-31.503 43.889-70.364 43.889-38.86 0-47.886-21.419-47.886-45.658s9.026-42.119 47.886-42.119 70.364 19.65 70.364 43.888"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#backup_card_svg__x)",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 647.379,
    cy: 277.875,
    fill: "#fff",
    rx: 57.5,
    ry: 52.176
  }))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#backup_card_svg__y)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 80.72,
    cy: 252.101,
    fill: "#fff",
    rx: 41.907,
    ry: 38.026
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#backup_card_svg__z)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 188.357,
    cy: 245.589,
    fill: "#fff",
    rx: 41.907,
    ry: 38.026
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#2A2A2A",
    strokeWidth: 0.6,
    d: "M238.793 206.629v48.09"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2A2A2A",
    strokeWidth: 0.8,
    d: "m-.019 127.067 20.909-1.817"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.5,
    d: "M238.78 237.791v-9.229"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2A2A2A",
    strokeWidth: 0.6,
    d: "m233.492 112.316 37.793-3.543"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#666",
    strokeWidth: 3,
    d: "M134.298 90.84v5.525a3 3 0 0 0 3 3h51.746a3 3 0 0 1 3 3v1.5M129.892 90.84v5.525a3 3 0 0 1-3 3H75.147a3 3 0 0 0-3 3v1.5",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#backup_card_svg__A)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#backup_card_svg__B)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    x: 146,
    y: 104,
    fill: "#FF000F",
    rx: 12
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#backup_card_svg__C)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M155.245 107.5h5.836l-3.932 7.181 6.601-2.628-7.677 14.879 2.876-9.726-5.856 2.462z"
  })))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#backup_card_svg__D)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42.857,
    height: 68.51,
    x: 50.604,
    y: 103.844,
    fill: "#F9F9F9",
    rx: 2
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#backup_card_svg__E)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37.23,
    height: 36.496,
    x: 53.46,
    y: 121.07,
    fill: "#fff",
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 37.03,
    height: 36.296,
    x: 53.56,
    y: 121.17,
    stroke: "#BABABA",
    strokeWidth: 0.2,
    rx: 0.4
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#DBDBDB",
    strokeWidth: 0.5,
    d: "M53.532 152.053h37.175m0-6.963h-5.718m-31.457 0h6.355m0 0v12.585m0-12.585h6.19m0 0v12.585m0-12.585h6.305m0 0v12.585m0-12.585h6.36m0 0v12.585m0-12.585h6.247m0 0v12.585"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#backup_card_svg__F)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 83.944,
    cy: 166.189,
    r: 2.79,
    fill: "#F5F5F5"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#backup_card_svg__G)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 83.944,
    cy: 110.33,
    r: 2.79,
    fill: "#F5F5F5"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#backup_card_svg__H)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 60.782,
    cy: 166.189,
    r: 2.79,
    fill: "#F5F5F5"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#backup_card_svg__I)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 60.782,
    cy: 110.33,
    r: 2.79,
    fill: "#F5F5F5"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#backup_card_svg__J)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 72.363,
    cy: 166.189,
    r: 2.79,
    fill: "#F5F5F5"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#backup_card_svg__K)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 72.363,
    cy: 110.33,
    r: 2.79,
    fill: "#F5F5F5"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#DBDBDB",
    strokeWidth: 0.5,
    d: "M66.493 103.895v17.248m12.7-17.248v17.248M66.043 124.66v16.818m12.699-16.818v16.818M66.197 157.387v15.022m12.625-15.022v15.022"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF000F",
    d: "M53.657 121.421a.3.3 0 0 1 .3-.3h36.224a.3.3 0 0 1 .3.3v3.017H53.657z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7.009,
    height: 8.533,
    x: 57.078,
    y: 133.094,
    fill: "#8B8B8B",
    rx: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 4.064,
    x: 54.531,
    y: 129.508,
    fill: "#8B8B8B",
    rx: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.259,
    height: 0.991,
    x: 55.69,
    y: 130.188,
    fill: "#F9F9F9",
    rx: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7.009,
    height: 8.533,
    x: 69.087,
    y: 133.094,
    fill: "#8B8B8B",
    rx: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7.009,
    height: 8.533,
    x: 81.096,
    y: 133.094,
    fill: "#8B8B8B",
    rx: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#backup_card_svg__L)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42.857,
    height: 68.51,
    x: 171.9,
    y: 103.844,
    fill: "#F9F9F9",
    rx: 2
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#backup_card_svg__M)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37.23,
    height: 36.496,
    x: 174.756,
    y: 121.07,
    fill: "#fff",
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 37.03,
    height: 36.296,
    x: 174.856,
    y: 121.17,
    stroke: "#BABABA",
    strokeWidth: 0.2,
    rx: 0.4
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#DBDBDB",
    strokeWidth: 0.5,
    d: "M174.828 152.053h37.175m0-6.963h-5.718m-31.457 0h6.354m0 0v12.585m0-12.585h6.192m0 0v12.585m0-12.585h6.304m0 0v12.585m0-12.585h6.36m0 0v12.585m0-12.585h6.247m0 0v12.585"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#backup_card_svg__N)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 205.24,
    cy: 166.189,
    r: 2.79,
    fill: "#F5F5F5"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#backup_card_svg__O)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 205.24,
    cy: 110.33,
    r: 2.79,
    fill: "#F5F5F5"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#backup_card_svg__P)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 182.078,
    cy: 166.189,
    r: 2.79,
    fill: "#F5F5F5"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#backup_card_svg__Q)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 182.078,
    cy: 110.33,
    r: 2.79,
    fill: "#F5F5F5"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#backup_card_svg__R)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 193.659,
    cy: 166.189,
    r: 2.79,
    fill: "#F5F5F5"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#backup_card_svg__S)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 193.659,
    cy: 110.33,
    r: 2.79,
    fill: "#F5F5F5"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#DBDBDB",
    strokeWidth: 0.5,
    d: "M187.789 103.895v17.248m12.699-17.248v17.248M187.339 124.66v16.818m12.699-16.818v16.818M187.493 157.387v15.022m12.625-15.022v15.022"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF000F",
    d: "M174.953 121.421a.3.3 0 0 1 .3-.3h36.224a.3.3 0 0 1 .3.3v3.017h-36.824z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7.009,
    height: 8.533,
    x: 178.374,
    y: 133.094,
    fill: "#8B8B8B",
    rx: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7.009,
    height: 8.533,
    x: 190.383,
    y: 133.094,
    fill: "#8B8B8B",
    rx: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7.009,
    height: 8.533,
    x: 202.392,
    y: 133.094,
    fill: "#8B8B8B",
    rx: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 4.064,
    x: 175.827,
    y: 141,
    fill: "#8B8B8B",
    rx: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.259,
    height: 0.991,
    x: 177,
    y: 142,
    fill: "#F9F9F9",
    rx: 0.2
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#959595",
    strokeWidth: 3,
    d: "M72.843 172.371v8.232a6 6 0 0 0 6.025 6l170.264-.72"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#backup_card_svg__T)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50.191,
    height: 80.234,
    x: 108,
    y: 12,
    fill: "#666",
    rx: 2
  })), /*#__PURE__*/React.createElement("rect", {
    width: 50.191,
    height: 80.234,
    x: 108,
    y: 12,
    fill: "#666",
    rx: 2
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#backup_card_svg__U)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 43.601,
    height: 34.343,
    x: 111.345,
    y: 36.16,
    fill: "#666",
    rx: 0.5
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 114.674,
    cy: 40.282,
    r: 1.7,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 114.95,
    cy: 73.829,
    r: 1.7,
    fill: "#A7A7A7"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#backup_card_svg__V)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31.048,
    height: 30.411,
    x: 117.344,
    y: 37.176,
    fill: "#666",
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 30.848,
    height: 30.211,
    x: 117.444,
    y: 37.276,
    stroke: "#666",
    strokeWidth: 0.2,
    rx: 0.4
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FF000F",
    d: "M117.367 38.175a.3.3 0 0 1 .3-.3h30.212a.3.3 0 0 1 .3.3v2.977h-30.812z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.208,
    height: 16.662,
    x: 129.265,
    y: 43.766,
    fill: "#F9F9F9",
    rx: 2.2
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#EBEBEB",
    strokeWidth: 0.1,
    d: "M118.392 70.777v2.555m0 6.67v-6.67m14.614-2.555v9.225m14.898-9.225v2.555m0 6.67v-6.67m-29.512 0h29.512"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#787878",
    stroke: "#EBEBEB",
    strokeWidth: 0.5,
    d: "M156.732 21.016v8.604h-12.694v-8.604zm-13.194 0v8.604h-33.98v-8.604zm-21.005 8.487h.5v-8.469h-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#EBEBEB",
    strokeWidth: 0.1,
    d: "M109.622 22.336h47.346m-47.346.993h47.346m-47.346.992h47.346m-47.346.993h47.346m-47.346.992h47.346m-47.346.993h47.346m-47.346.993h47.346"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#backup_card_svg__W)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    d: "M108.32 80.289h49.871v.741H108.32z"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    d: "m117.344 41 4.394-.008 4.394-.007M140.55 41h7.629"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FCDB2E",
    strokeWidth: 0.8,
    d: "M121.694 49.688H128"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00DD16",
    strokeWidth: 1.5,
    d: "M121.694 60.117H128"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#DBDBDB",
    strokeWidth: 1.5,
    d: "M148.393 45h-2.436M117.367 45.055h3.638M148.393 60.117h-2.436M117.367 60.117h3.638"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#DBDBDB",
    d: "M117.367 49.688h3.638M145.673 49.688h2.752"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FF000F",
    strokeWidth: 2,
    d: "M121.357 45h5.143000000000001M140 45h5.5"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00DD16",
    strokeWidth: 0.8,
    d: "M140 49.688h5.009"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00DD16",
    strokeWidth: 1.5,
    d: "M140 60.117h5.5"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#backup_card_svg__X)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.828,
    height: 7.102,
    x: 126.427,
    y: 54.863,
    fill: "#F9F9F9",
    rx: 1
  })), /*#__PURE__*/React.createElement("rect", {
    width: 9.417,
    height: 1.82,
    x: 128.661,
    y: 56.152,
    fill: "#2A2A2A",
    rx: 0.2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "backup_card_svg__t",
    width: 223.344,
    height: 41.195,
    x: 233.08,
    y: 93.59,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.238462 0 0 0 0 0.238232 0 0 0 0 0.238232 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4233_33514"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4233_33514",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "backup_card_svg__u",
    width: 314.554,
    height: 112.678,
    x: -5.873,
    y: -3.019,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_4233_33514",
    stdDeviation: 2.9
  })), /*#__PURE__*/React.createElement("filter", {
    id: "backup_card_svg__v",
    width: 237.4,
    height: 48.4,
    x: 439.679,
    y: 255.175,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_4233_33514",
    stdDeviation: 6.35
  })), /*#__PURE__*/React.createElement("filter", {
    id: "backup_card_svg__w",
    width: 249.25,
    height: 218.777,
    x: 390.372,
    y: 161.375,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_4233_33514",
    stdDeviation: 32.75
  })), /*#__PURE__*/React.createElement("filter", {
    id: "backup_card_svg__x",
    width: 246,
    height: 235.352,
    x: 524.379,
    y: 160.199,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_4233_33514",
    stdDeviation: 32.75
  })), /*#__PURE__*/React.createElement("filter", {
    id: "backup_card_svg__y",
    width: 214.813,
    height: 207.051,
    x: -26.686,
    y: 148.574,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_4233_33514",
    stdDeviation: 32.75
  })), /*#__PURE__*/React.createElement("filter", {
    id: "backup_card_svg__z",
    width: 214.813,
    height: 207.055,
    x: 80.951,
    y: 142.062,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_4233_33514",
    stdDeviation: 32.75
  })), /*#__PURE__*/React.createElement("filter", {
    id: "backup_card_svg__A",
    width: 55.8,
    height: 55.8,
    x: 130.1,
    y: 88.1,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4233_33514"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.95
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 0.413846 0 0 0 0 0.0230772 0 0 0 0.7 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_4233_33514",
    result: "effect2_dropShadow_4233_33514"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_4233_33514",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "backup_card_svg__C",
    width: 18.657,
    height: 27.434,
    x: 149.093,
    y: 103.5,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4233_33514"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4233_33514",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "backup_card_svg__D",
    width: 54.257,
    height: 79.966,
    x: 44.904,
    y: 102.144,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.85
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4233_33514"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4233_33514",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "backup_card_svg__E",
    width: 45.23,
    height: 44.496,
    x: 49.46,
    y: 121.07,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.18 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4233_33514"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4233_33514",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "backup_card_svg__F",
    width: 5.581,
    height: 9.582,
    x: 81.153,
    y: 163.398,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_4233_33514"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "backup_card_svg__G",
    width: 5.581,
    height: 9.582,
    x: 81.153,
    y: 107.539,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_4233_33514"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "backup_card_svg__H",
    width: 5.581,
    height: 9.582,
    x: 57.991,
    y: 163.398,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_4233_33514"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "backup_card_svg__I",
    width: 5.581,
    height: 9.582,
    x: 57.991,
    y: 107.539,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_4233_33514"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "backup_card_svg__J",
    width: 5.581,
    height: 9.582,
    x: 69.572,
    y: 163.398,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_4233_33514"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "backup_card_svg__K",
    width: 5.581,
    height: 9.582,
    x: 69.572,
    y: 107.539,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_4233_33514"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "backup_card_svg__L",
    width: 54.257,
    height: 79.966,
    x: 166.2,
    y: 102.144,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.85
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4233_33514"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4233_33514",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "backup_card_svg__M",
    width: 45.23,
    height: 44.496,
    x: 170.756,
    y: 121.07,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.18 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4233_33514"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4233_33514",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "backup_card_svg__N",
    width: 5.581,
    height: 9.582,
    x: 202.449,
    y: 163.398,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_4233_33514"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "backup_card_svg__O",
    width: 5.581,
    height: 9.582,
    x: 202.449,
    y: 107.539,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_4233_33514"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "backup_card_svg__P",
    width: 5.581,
    height: 9.582,
    x: 179.287,
    y: 163.398,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_4233_33514"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "backup_card_svg__Q",
    width: 5.581,
    height: 9.582,
    x: 179.287,
    y: 107.539,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_4233_33514"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "backup_card_svg__R",
    width: 5.581,
    height: 9.582,
    x: 190.868,
    y: 163.398,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_4233_33514"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "backup_card_svg__S",
    width: 5.581,
    height: 9.582,
    x: 190.868,
    y: 107.539,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_4233_33514"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "backup_card_svg__T",
    width: 61.591,
    height: 91.634,
    x: 102.3,
    y: 10.3,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.85
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4233_33514"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4233_33514",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "backup_card_svg__U",
    width: 51.601,
    height: 42.344,
    x: 107.345,
    y: 32.16,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4233_33514"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4233_33514",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "backup_card_svg__V",
    width: 39.048,
    height: 38.41,
    x: 113.344,
    y: 37.176,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4233_33514"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4233_33514",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "backup_card_svg__W",
    width: 70.472,
    height: 21.342,
    x: 98.02,
    y: 73.989,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4233_33514"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4233_33514",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "backup_card_svg__X",
    width: 21.828,
    height: 15.102,
    x: 122.427,
    y: 54.863,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4233_33514"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4233_33514",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "backup_card_svg__b",
    x1: 10.773,
    x2: 10.773,
    y1: 0,
    y2: 21.815,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DAA96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#274326"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "backup_card_svg__c",
    x1: 10.773,
    x2: 10.773,
    y1: 0,
    y2: 21.815,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DAA96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#274326"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "backup_card_svg__d",
    x1: 9.819,
    x2: 9.819,
    y1: 0,
    y2: 20.907,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DAA96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#274326"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "backup_card_svg__e",
    x1: 13.269,
    x2: 13.269,
    y1: 0,
    y2: 28.252,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DAA96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#274326"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "backup_card_svg__f",
    x1: 18.473,
    x2: 18.473,
    y1: 0,
    y2: 38.297,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DAA96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#274326"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "backup_card_svg__g",
    x1: 11.556,
    x2: 11.556,
    y1: 0,
    y2: 23.956,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DAA96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#274326"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "backup_card_svg__h",
    x1: 11.556,
    x2: 11.556,
    y1: 0,
    y2: 23.956,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DAA96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#274326"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "backup_card_svg__i",
    x1: 11.556,
    x2: 11.556,
    y1: 0,
    y2: 23.956,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DAA96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#274326"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "backup_card_svg__j",
    x1: 8.076,
    x2: 8.076,
    y1: 0,
    y2: 16.743,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DAA96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#274326"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "backup_card_svg__k",
    x1: 8.076,
    x2: 8.076,
    y1: 0,
    y2: 16.743,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DAA96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#274326"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "backup_card_svg__l",
    x1: 12.892,
    x2: 12.892,
    y1: 0,
    y2: 26.726,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DAA96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#274326"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "backup_card_svg__m",
    x1: 18.473,
    x2: 18.473,
    y1: 0,
    y2: 38.297,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DAA96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#274326"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "backup_card_svg__n",
    x1: 18.473,
    x2: 18.473,
    y1: 0,
    y2: 38.297,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DAA96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#274326"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "backup_card_svg__o",
    x1: 8.612,
    x2: 8.612,
    y1: 0,
    y2: 17.855,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DAA96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#274326"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "backup_card_svg__p",
    x1: 6.712,
    x2: 6.712,
    y1: 0,
    y2: 13.914,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DAA96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#274326"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "backup_card_svg__q",
    x1: 5.189,
    x2: 5.189,
    y1: 0,
    y2: 10.757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DAA96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#274326"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "backup_card_svg__r",
    x1: 5.189,
    x2: 5.189,
    y1: 0,
    y2: 10.757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DAA96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#274326"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "backup_card_svg__s",
    x1: 3.986,
    x2: 3.986,
    y1: 0,
    y2: 8.263,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DAA96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#274326"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "backup_card_svg__a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 700,
    height: 301,
    fill: "#fff",
    rx: 8
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "backup_card_svg__B"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    x: 146,
    y: 104,
    fill: "#fff",
    rx: 12
  })))));
};
export default SvgBackupCard;